import React from 'react'
import PropTypes from 'prop-types'
import 'react-datepicker/dist/react-datepicker.css'
import { useModel, useValue } from '@morningtrain/react-resources'
import WeekFilter from 'support/filters/WeekFilter'
import { Env } from '@morningtrain/helpers'
import moment from 'moment'
import { getMapValue } from '@morningtrain/react-helpers'

function WeekFilterSyncedWithModel (props) {
  const id = useValue('id')
  const model = useModel()

  const year = getMapValue(model, 'year', Env.get('page.filters.week.defaultValue.year') || moment().weekYear())
  const week = getMapValue(model, 'week', Env.get('page.filters.week.defaultValue.week') || moment().week())

  const [value, setValue] = React.useState({ year, week })

  React.useEffect(() => {
    const year = getMapValue(model, 'year', Env.get('page.filters.week.defaultValue.year') || moment().weekYear())
    const week = getMapValue(model, 'week', Env.get('page.filters.week.defaultValue.week') || moment().week())

    setValue({ year, week })
  }, [id])

  return <WeekFilter key={[week, year].join('.')} name={props.name} defaultValue={value} />
}

WeekFilterSyncedWithModel.propTypes = {
  name: PropTypes.string.isRequired
}

export default WeekFilterSyncedWithModel
